import axios from 'axios'

class UsersService
{
    constructor(accessToken) {
        this.accessToken = accessToken;
    }

    get = async () => {
        return axios.get('/api/users', {
                headers: {
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
            .then(result => result)
            .catch(error => {
                if ('response' in error && error.response !== undefined) {
                    throw error.response.data;
                }
                else {
                    throw error;
                }
            });
    }

    create = async (email) => {
        return axios.post('/api/users',{email: email}, {
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            }
        })
            .then(result => result)
            .catch(error => {
                if ('response' in error && error.response !== undefined) {
                    throw error.response.data;
                }
                else {
                    throw error;
                }
            });
    }

    delete = async (email) => {
        return axios.delete('/api/users',{
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            },
            data: {
                email: email
            }
        })
            .then(result => result)
            .catch(error => {
                if ('response' in error && error.response !== undefined) {
                    throw error.response.data;
                }
                else {
                    throw error;
                }
            });
    }
}

export default UsersService;
